import { createApiFetch } from '@mbbe/config';

export const apiFetch = createApiFetch();
